import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "app/authHooks";
import restUtils from "core/utils/rest";

export type Permission = string; // e.g., "view:dashboard"

const PermissionsContext = createContext<Permission[]>([]);

export const PermissionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { attributes } = useAuth();
  const [permissions, setPermissions] = useState<Permission[]>([]);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (attributes?.["custom:role"]) {
        console.log("USER ATTRIBUTES::  " , attributes);
        const roleName = attributes["custom:role"];
        try {
          const response = await restUtils.call<any>("UserManagementApi", `user-roles/by-name/${roleName}`, "GET");
          const fetchedPerms = response.map((p: { name: string }) => p.name);
          console.log("FETCHED PERMISSIONS FOR ROLE", roleName, ":", fetchedPerms);
          setPermissions(fetchedPerms);
        } catch (error) {
          console.error("Failed to fetch permissions:", error);
          console.log("FALLING BACK TO EMPTY PERMISSIONS");
          setPermissions([]); // Fallback to no permissions
        }
      }
    };
    fetchPermissions();
  }, [attributes]);

  return <PermissionsContext.Provider value={permissions}>{children}</PermissionsContext.Provider>;
};

export function hasPermission(permission: Permission): boolean {
  const permissions = useContext(PermissionsContext);
  return permissions.includes(permission);
}
